import { usePitcher } from "features/utils/usePitcher";
import { useEffect, useState } from "react";

export const usePitcherHibernating = () => {
  const pitcher = usePitcher();
  const [isHibernating, setIsHibernating] = useState(false);

  useEffect(() => {
    const hibernateDisposer = pitcher.clients.system.onHibernate(() => {
      setIsHibernating(true);
    });
    const stateChangeDisposer = pitcher.onStateChange(({ state }) => {
      if (state === "CONNECTED") {
        setIsHibernating(false);
      }
    });

    return () => {
      hibernateDisposer.dispose();
      stateChangeDisposer();
    };
  }, []);

  return isHibernating;
};
